import { useState } from 'react';

export const useForm = <T extends Object>( initialForm : T ) => {
  
    const [ formState, setFormState ] = useState( initialForm );

    const onInputChange = ({ target }) => {
        var { name, value, checked } = target;

        if(target.classList && target.classList.contains('onlyInteger')){
            const regex = /^[0-9]*$/;
    
            if (!regex.test(value)) {
              // If the entered value contains non-numeric characters, prevent the input
              target.value = formState[name];
              value = formState[name];
            }
            //if(value != "") 
              //  value = parseInt(value);
        }
        
        // Forma funcional: varios cambios seguidos no se pisan entre sí
        setFormState(prev => ({
            ...prev,
            [ name ]: target.type === 'checkbox' ? checked : value
        }));
    }

    const onResetForm = () => {
        setFormState( initialForm );
    }

    

    return {
        ...formState,
        formState,
        onInputChange,
        onResetForm,
    }
}